import React from 'react';
import Toggle from '../../../Toggle';
import { useHubSite } from '../../shared';
import TemplateCard from './TemplateCard';
import { ContactFormSettings, TabProps } from './formSettingsData';

type TextKey = 'consentWording' | 'privacyLine' | 'thankYouMessage' | 'redirectUrl';

// Form settings › Consent & after send (spec 713:5854). The thank-you message and the redirect are either / or.
const Consent: React.FC<TabProps> = ({ form, setForm }) => {
    const { short } = useHubSite();
    const set = (key: TextKey) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setForm(f => ({ ...f, [key]: value }));
    };

    const row = (title: string, hint: string, key: keyof Pick<ContactFormSettings, 'optIn' | 'thankYou' | 'redirect'>, onChange: (v: boolean) => void) =>
        <div className="setting-row hub-fs-plain-row">
            <div className="text"><div className="title">{title}</div><div className="hint">{hint}</div></div>
            <Toggle label={title} checked={form[key]} onChange={onChange} />
        </div>;

    return <section className="card">
        <div className="section-title">
            <div className="text">
                <h2>Consent and what happens next</h2>
                <div className="hint">The tick-box under the form, and what the visitor sees once they press send</div>
            </div>
        </div>

        {row('Offer the announcement opt-in', 'A tick-box: “Also send me announcements by email.” Anyone who ticks it is added to Contacts as subscribed.', 'optIn',
            optIn => setForm(f => ({ ...f, optIn })))}
        <TemplateCard off={!form.optIn} name={`Welcome email — ${short}`} button="Edit the Welcome Email"
            intro="Anyone who ticks the box is subscribed and gets the same Welcome email as a sign-up from the website — their password and a link to manage what they receive." />

        <label className="field hub-fs-field">
            <span className="hub-fs-label">Consent wording</span>
            <input value={form.consentWording} disabled={!form.optIn} onChange={set('consentWording')} />
        </label>
        <label className="field hub-fs-field">
            <span className="hub-fs-label">Privacy line under the button</span>
            <input value={form.privacyLine} onChange={set('privacyLine')} />
        </label>

        {row('Show a thank-you message on the page', 'Instead of reloading the page.', 'thankYou',
            thankYou => setForm(f => ({ ...f, thankYou, redirect: thankYou ? false : f.redirect })))}
        <label className="field hub-fs-field">
            <span className="hub-fs-label">Thank-you message</span>
            <textarea rows={2} value={form.thankYouMessage} disabled={!form.thankYou} onChange={set('thankYouMessage')} />
        </label>

        {row('Send them to a page instead', 'Useful if you track form completions in Google Analytics.', 'redirect',
            redirect => setForm(f => ({ ...f, redirect, thankYou: redirect ? false : f.thankYou })))}
        <label className="field hub-fs-field">
            <span className="hub-fs-label">Redirect URL</span>
            <input value={form.redirectUrl} disabled={!form.redirect} placeholder="/contact-us/thank-you/" onChange={set('redirectUrl')} />
        </label>
    </section>;
};

export default Consent;
